import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-fullscreen-loading-spinner',
  templateUrl: './fullscreen-loading-spinner.component.html',
  styleUrls: ['./fullscreen-loading-spinner.component.scss'],
  standalone: false,
})
export class FullscreenLoadingSpinnerComponent {
  readonly loading$: Observable<boolean>;

  constructor(private readonly loadingService: LoadingService) {
    this.loading$ = this.loadingService.getObservable();
  }
}
